// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.custom-ui {
  font-family: "OpenSans-Regular";
  color: var(--undp-jtf-btn-dark-color);
}

.forms-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem 1rem;
  width: 100%;
}

.forms-toolbar__label {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.35rem;
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  color: var(--undp-jtf-btn-dark-color);
}

.forms-toolbar__label-text {
  font-size: 0.95rem;
  white-space: nowrap;
}

.forms-toolbar__select {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

@media (min-width: 576px) {
  .forms-toolbar__label {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }
  .forms-toolbar__select {
    flex: 1 1 240px;
    width: auto;
    max-width: min(100%, 420px);
  }
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/forms/forms.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,+BCEqB;EDDrB,qCAAA;AAEF;;AACA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;AAEF;;AACA;EACE,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,YAAA;AAEF;;AACA;EACE;IACE,mBAAA;IACA,mBAAA;IACA,eAAA;EAEF;EACA;IACE,eAAA;IACA,WAAA;IACA,2BAAA;EACF;AACF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n\n.custom-ui {\n  font-family: $primary-font-regular;\n  color: var(--undp-jtf-btn-dark-color);\n}\n\n.forms-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.5rem 1rem;\n  width: 100%;\n}\n\n.forms-toolbar__label {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.35rem;\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  max-width: 100%;\n  color: var(--undp-jtf-btn-dark-color);\n}\n\n.forms-toolbar__label-text {\n  font-size: 0.95rem;\n  white-space: nowrap;\n}\n\n.forms-toolbar__select {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n@media (min-width: 576px) {\n  .forms-toolbar__label {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n\n  .forms-toolbar__select {\n    flex: 1 1 240px;\n    width: auto;\n    max-width: min(100%, 420px);\n  }\n}\n\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
